module.exports = __webpack_public_path__ + "static/media/flowchart.5f05bd66.svg";